/** Typed-signature fonts. The stored `font_type` is the family name, so the order and spelling are a contract. */
export const SIGNATURE_FONTS = ['Kaushan Script', 'Nothing You Could Do', 'Caveat', 'Fuzzy Bubbles'] as const;
export type SignatureFont = (typeof SIGNATURE_FONTS)[number];
export const DEFAULT_SIGNATURE_FONT: SignatureFont = SIGNATURE_FONTS[0];

export const MAX_SIGNATURE_IMAGE_BYTES = 12 * 1024 * 1024;
export const MAX_PDF_BYTES = 25 * 1024 * 1024;

/**
 * Signature pad size, shared by every signing flow: a 3:1 strip, the usual proportion of signature capture pads and
 * e-sign tools. The pad shrinks with its container and keeps this ratio.
 */
export const SIGNATURE_PAD_WIDTH = 600;
export const SIGNATURE_PAD_HEIGHT = 200;
/** Height floor for phones, where a 3:1 strip would be too short to sign with a finger. */
export const SIGNATURE_PAD_MIN_HEIGHT = 140;

export const SIGNATURE_PNG_FILE_NAME = 'signature.png';
export const MAX_TYPED_SIGNATURE_LENGTH = 60;

export const getSignatureFontFamily = (font: string) => `'${font}', cursive`;

export const isSignatureFont = (value: string): value is SignatureFont =>
  (SIGNATURE_FONTS as readonly string[]).includes(value);
